import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';

@Injectable({ providedIn: 'root' })
export class RoleRedirectGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const role = this.storageService.getRole();
    if (role === 'CLIENT') {
      this.router.navigate(['/doqfy/dashboard']);
    } else {
      this.router.navigate(['/doqfy/admin-dashboard']);
    }
    return false;
  }
}
